import * as React from "react";
import * as _ from "lodash";
import { IUser, ITicketGroup, IUserItem, ICenter } from "@nkr/models/index";
import { Modal, Button, FormControl, Panel, Glyphicon } from "react-bootstrap";
import GroupUsersList from "./group-users-list";

interface IProps {
    show: boolean,
    group: ITicketGroup,
    userList: IUser[],
    centerList: ICenter[],
    onSave: (groupId, users: IUserItem[]) => void,
    onCancel: () => void
}

interface IState {
    centerId: number,
    availableUsers: IUserItem[],
    assignedUsers: IUserItem[]
}

class GroupUsers extends React.Component<IProps, IState> {
    readonly state: IState = {
        centerId: 0,
        availableUsers: [],
        assignedUsers: []
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        let availableUsers: IUserItem[] = nextProps.userList.map(user => {
            return {
                user,
                isAssigned: false,
                isPrimary: false,
                selected: false
            };
        });

        let assignedUsers: IUserItem[] = [];

        if (nextProps.group) {
            assignedUsers = nextProps.group.users.map(tgu => {
                return {
                    user: tgu.user,
                    isAssigned: true,
                    isPrimary: tgu.isPrimary,
                    selected: false
                };
            });
        }

        this.setState({
            centerId: 0,
            availableUsers,
            assignedUsers
        });
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            centerId: parseInt(e.currentTarget.value)
        });
    }

    handleAvailableSelect = (item: IUserItem) => {
        let availableUsers = _.cloneDeep(this.state.availableUsers).map(x => {
            if (x.user.id == item.user.id)
                x.selected = !x.selected;

            return x;
        });

        this.setState({
            availableUsers
        });
    }

    handleAssignedSelect = (item: IUserItem) => {
        let assignedUsers = _.cloneDeep(this.state.assignedUsers).map(x => {
            if (x.user.id == item.user.id)
                x.selected = !x.selected;

            return x;
        });

        this.setState({
            assignedUsers
        });
    }

    handleSelectPrimary = (item: IUserItem) => {
        let assignedUsers = _.cloneDeep(this.state.assignedUsers).map(x => {
            if (x.user.id == item.user.id)
                x.isPrimary = !x.isPrimary;
            else
                x.isPrimary = false;

            return x;
        });

        this.setState({
            assignedUsers
        });
    }

    handleAdd = () => {
        let selected = this.state.availableUsers.filter(item => item.selected);
        let availableUsers = _.cloneDeep(this.state.availableUsers.filter(item => !item.selected));
        let assignedUsers = _.cloneDeep(this.state.assignedUsers);

        selected.forEach(item => {
            item.selected = false;
            item.isAssigned = true;
            assignedUsers.push(item);
        });

        this.setState({
            availableUsers,
            assignedUsers
        });
    }

    handleRemove = () => {
        let selected = this.state.assignedUsers.filter(item => item.selected);
        let availableUsers = _.cloneDeep(this.state.availableUsers);
        let assignedUsers = _.cloneDeep(this.state.assignedUsers.filter(item => !item.selected));

        selected.forEach(item => {
            item.selected = false;
            item.isAssigned = false;
            availableUsers.push(item);
        });

        this.setState({
            availableUsers,
            assignedUsers
        });
    }

    handleSave = () => {
        let assignedUsers = _.cloneDeep(this.state.assignedUsers);
        this.props.onSave(this.props.group.id, assignedUsers);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        if (this.props.group == null)
            return null;

        const availableUsers = this.state.availableUsers.filter(item => {
            var f = this.props.group.users.find(x => x.userId == item.user.id);

            if (!this.props.group.isNkr) {
                if (this.state.centerId > 0)
                    return f == null && (item.user.centerId == this.state.centerId || item.user.centerId == 0);
                else
                    return item.user.centerId == 0;
            } else {
                return item.user.centerId == 0 && f == null;
            }
        });

        const sortedAvailableUsers = _.orderBy(availableUsers, (item: IUserItem) => {
            return item.user.lastName;
        });

        const sortedAssignedUsers = _.orderBy(this.state.assignedUsers, (item: IUserItem) => {
            return item.user.lastName;
        });

        return (
            <>
                <Modal bsSize="large" show={this.props.show} onHide={() => null}>
                    <Modal.Header className="h4">
                        Assign Users
                    </Modal.Header>

                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="alert alert-info">
                                <div className="row" style={{ height: 34, display: "flex", alignItems: "center" }}>
                                    <div className="col-xs-12 col-lg-1">Group:</div>
                                    <div className="col-xs-12 col-lg-11">
                                        <strong>{this.props.group.name}</strong>
                                    </div>
                                </div>

                                {this.props.group.isNkr && (
                                    <div className="row" style={{ height: 34, display: "flex", alignItems: "center" }}>
                                        <div className="col-xs-12 col-lg-1">Type:</div>
                                        <div className="col-xs-12 col-lg-11">
                                            Internal Group (NKR Only)
                                    </div>
                                    </div>
                                )}

                                {!this.props.group.isNkr && (
                                    <>
                                        <div className="row" style={{ height: 34, display: "flex", alignItems: "center" }}>
                                            <div className="col-xs-12 col-lg-1">Type:</div>
                                            <div className="col-xs-12 col-lg-11">
                                                Public Group
                                        </div>
                                        </div>
                                        <div className="row" style={{ height: 34, display: "flex", alignItems: "center" }}>
                                            <div className="col-xs-12 col-lg-1">
                                                Center:
                                        </div>
                                            <div className="col-xs-12 col-lg-11">
                                                <FormControl
                                                    componentClass="select"
                                                    value={this.state.centerId}
                                                    onChange={this.handleCenterChange}
                                                >
                                                    <option value="0">- Select Center -</option>
                                                    {this.props.centerList.map((center, index) =>
                                                        <option value={center.id}>{center.alias}</option>
                                                    )}
                                                </FormControl>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            <Panel>
                                <Panel.Heading>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <div>Available Users</div>
                                        <div>
                                            <Button bsStyle="primary" bsSize="xs" onClick={this.handleAdd}>Add Checked</Button>
                                        </div>
                                    </div>
                                </Panel.Heading>
                                <Panel.Body>
                                    <GroupUsersList
                                        items={sortedAvailableUsers}
                                        message={!this.props.group.isNkr && this.state.centerId == 0 && sortedAvailableUsers.length == 0 ? "Please select a center" : ""}
                                        onSelect={this.handleAvailableSelect}
                                        onSelectPrimary={() => null}
                                    />
                                </Panel.Body>
                            </Panel>

                            <Panel>
                                <Panel.Heading>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <div>Assigned Users</div>
                                        <div>
                                            <Button bsStyle="primary" bsSize="xs" onClick={this.handleRemove}>Remove Checked</Button>
                                        </div>
                                    </div>
                                </Panel.Heading>
                                <Panel.Body>
                                    <GroupUsersList
                                        items={sortedAssignedUsers}
                                        message={''}
                                        onSelect={this.handleAssignedSelect}
                                        onSelectPrimary={this.handleSelectPrimary}
                                    />
                                </Panel.Body>
                            </Panel>

                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: 5 }}>* Note: </div>
                                <div style={{ backgroundColor: "#87B7CF", color: "darkblue", borderRadius: 4, padding: 5, marginRight: 5 }}>NKR User</div>
                                <div style={{ backgroundColor: "#CCC314", color: "darkblue", borderRadius: 4, padding: 5, marginRight: 5 }}>Center User</div>
                                <div style={{ border: "1px solid #ccc", borderRadius: 4, padding: 5 }} ><Glyphicon glyph="star" style={{ color: "red" }} /> Primary for the group</div>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={this.handleSave}>Save</Button>
                        <Button onClick={this.handleCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default GroupUsers;